<template>
  <form-layout :loading="isUpdatingProcurement" @save="updateProcurement">
    <template #title>
      <h1 class="uppercase">Delivery Failure</h1>
    </template>
    <template #body>
      <div class="procurement-info">
        <p class="text-lg">{{ procurement.name }}</p>
        <p class="mt-2">{{ procurement.contractContactName }}</p>
        <template v-if="procurement.contract && procurement.contract.place">
          <p>
            {{ procurement.contract.place.streetAddress }}
          </p>
          <p>{{ procurement.contract.place.cityStateZip }}</p>
        </template>
      </div>

      <bdg-radios-group
        ref="type"
        name="Reason for delivery failure"
        :options="statusOptions"
        v-model="formData.type"
        required
      />

      <bdg-text-area
        ref="note"
        name="Note"
        v-model="formData.note.text"
        required
      />
    </template>
  </form-layout>
</template>

<script>
import FormLayout from "../views/layouts/FormLayout";
import { Procurement } from "../models/Procurement";
import BdgRadiosGroup from "./fields/BdgRadiosGroup";
import BdgTextArea from "./fields/BdgTextArea";
import { ProcurementStatuses } from "../constants/contract-enums";
import { validateRequiredRefs } from "../helpers";

export default {
  name: "DeliveryFailureForm",
  components: { BdgTextArea, BdgRadiosGroup, FormLayout },
  props: {
    procurement: Procurement
  },
  data() {
    return {
      formData: {
        ...this.procurement
      },
      statusOptions: [
        {
          label: "Delivery on hold",
          value: ProcurementStatuses.ON_HOLD
        },
        {
          label: "Delivery cancelled",
          value: ProcurementStatuses.CANCELLED
        }
      ],
      requiredRefs: ["type", "note"]
    };
  },
  computed: {
    isUpdatingProcurement() {
      return this.$store.Contracts.Procurements.isUpdatingProcurement;
    }
  },
  methods: {
    validate() {
      return validateRequiredRefs(this, true);
    },
    updateProcurement() {
      if (!this.validate()) {
        return;
      }

      this.$store.dispatch("updateProcurement", {
        ...this.formData,
        dispatchAction: "getScheduledDeliveries"
      });
    }
  }
};
</script>

<style scoped></style>
